import { render, staticRenderFns } from "./NewLicenseKind.vue?vue&type=template&id=71f4bdc2&scoped=true"
import script from "./NewLicenseKind.vue?vue&type=script&lang=js"
export * from "./NewLicenseKind.vue?vue&type=script&lang=js"
import style0 from "./NewLicenseKind.vue?vue&type=style&index=0&id=71f4bdc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f4bdc2",
  null
  
)

export default component.exports